import React from "react";
import Dialog from "@mui/material/Dialog";
import { Form, Formik, FormikHelpers } from "formik";
import { object, string } from "yup";
import { SubjectFormValues } from "src/models/Subject.model";
import Subject from "../Layouts/SubjectForm";
import { useAddSubjectMutation } from "src/services/SubjectService";
import { showToast } from "src/utils/showToaster";

type Props = {
  onClose: () => void;
};

const AddSubjectWrapper = ({ onClose }: Props) => {
  // Form Initial Values
  const initialValues: SubjectFormValues = {
    subjectName: "",
  };
  const [addSubject] = useAddSubjectMutation();

  // Validation Schema
  const validationSchema = object().shape({
    subjectName: string().required("Please enter subject name"),
  });

  // Handle Submit
  const handleSubmit = (
    values: SubjectFormValues,
    { setSubmitting, resetForm }: FormikHelpers<SubjectFormValues>
  ) => {
    addSubject(values).then((res: any) => {
      if (res?.error) {
        showToast("error", res?.error?.data?.message);
      } else {
        if (res?.data?.status) {
          showToast("success", res?.data?.message);
          resetForm();
          onClose();
        } else {
          showToast("error", res?.data?.message);
        }
      }
      setSubmitting(false);
    });
  };

  return (
    <Dialog open maxWidth="xs" fullWidth>
      <Formik
        initialValues={initialValues}
        validationSchema={validationSchema}
        onSubmit={handleSubmit}
      >
        {(formikProps) => (
          <Form>
            <Subject
              formikProps={formikProps}
              onClose={onClose}
              formType="ADD"
            />
          </Form>
        )}
      </Formik>
    </Dialog>
  );
};

export default AddSubjectWrapper;
